<template>
  <div class="otherFormquote">
    <b-loading :is-full-page="isFullPage" v-model="isLoading"></b-loading>

    <div id="message">
      <b-message title="Demande reçue" type="is-success">
        Merci , un conseiller de capiassur va vous contacter <br />
        Merci de choisir CAPIASSUR.
      </b-message>
    </div>

    <div class="formular" id="formularor">
      <form-wizard
        ref="formwizard"
        @onComplete="onComplete"
        @onNextStep="nextStep"
        @onPreviousStep="previousStep"
        @onReset="reset"
      >
        <tab-content title="Commencer" :selected="true">
          <IntroductionHabitation></IntroductionHabitation>
          <span v-on:click="Validate1()" id="validation1" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Type de Logement">
          <div id="typlelog">
            <h1 class="titleprimary">
              <span class="titlecolorized">Mon type de </span>
              <span class="titlenoncolorized">logement</span>
            </h1>

            <div class="block blockCenter columns justufuCenter">
                <div class="containerAsurence">
                  <div :class="FormularData.TypeLogement!='Maison'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeLogement = 'Maison' ">
                    <img src="../../assets/imgused/house.png" class="imgauto" />
                    <span class="radiotitlewithimage">Maison</span>
                  </div>  
                  <div :class="FormularData.TypeLogement!='Appartement'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeLogement = 'Appartement' ">
                    <img src="../../assets/imgused/appartment.png" class="imgauto" />
                    <span class="radiotitlewithimage">Appartement</span>
                  </div>  
                </div>
            </div>
          </div>
          <div class="el-empty-space"></div>
          <div
            id="ifisAppartement"
            v-if="FormularData.TypeLogement == 'Appartement'"
          >
            <h1 class="titleprimary">
              <span class="titlecolorized">À quel </span>
              <span class="titlenoncolorized"> étage </span>
              <span class="titlecolorized">habitez vous ? </span>
            </h1>

            <div class="block blockCenter columns justufuCenter">
              <div class="containerAsurence">
                <div :class="FormularData.TypeAppartement!='Rez-de-chaussée'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeAppartement = 'Rez-de-chaussée' ">
                  <img src="../../assets/imgused/rdz.png" class="imgauto" />
                  <span class="radiotitlewithimage">Rez-de-chaussée</span>
                </div>  
                <div :class="FormularData.TypeAppartement!='Niveaux supérieurs'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeAppartement = 'Niveaux supérieurs' ">
                  <img src="../../assets/imgused/superior.png" class="imgauto" />
                  <span class="radiotitlewithimage">Niveaux supérieurs</span>
                </div>  
              </div>
            </div>
          </div>

          <span v-on:click="Validate2()" id="validation2" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Proprietaire">
          <h1 class="titleprimary">
            <span class="titlecolorized">Comment ai-je acheté </span>
            <span class="titlenoncolorized"> mon Logement ?</span>
          </h1>

          <div class="block blockCenter columns justufuCenter">
            <div class="containerAsurence">
              <div :class="FormularData.isOwner!='Oui'? 'box big-box' : ' big-box box boxActive'" v-on:click="() => FormularData.isOwner = 'Oui' ">
                <img src="../../assets/imgused/owner.png" class="imgauto" />
                <span class="radiotitlewithimage">Propriétaire</span>
              </div>  
              <div :class="FormularData.isOwner!='Non'? 'box big-box' : 'box big-box boxActive'" v-on:click="() => FormularData.isOwner = 'Non' ">
                <img src="../../assets/imgused/leasing.png" class="imgauto" />
                <span class="radiotitlewithimage">Location LOA/LLD</span>
              </div>  
            </div>
          </div>

          <span v-on:click="Validate3()" id="validation3" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Proprietaire">
          <div id="propoirii">
            <h1 class="titleprimary">
              <span class="titlecolorized">Mon utilisation du </span>
              <span class="titlenoncolorized"> logement</span>
            </h1>

            <div class="block blockCenter columns justufuCenter">
              <div class="containerAsurence">
                <div :class="FormularData.Utilisation!='Résidence principale'? 'box small-box' : 'small-box box boxActive'" v-on:click="() => FormularData.Utilisation = 'Résidence principale' ">
                  <img src="../../assets/imgused/primaire.png" class="imgauto" />
                  <span class="radiotitlewithimage">Résidence principale</span>
                </div>  
                <div :class="FormularData.Utilisation!='Résidence secondaire'? 'box small-box' : 'small-box box boxActive'" v-on:click="() => FormularData.Utilisation = 'Résidence secondaire' ">
                  <img src="../../assets/imgused/secondaire.png" class="imgauto" />
                  <span class="radiotitlewithimage">Résidence secondaire</span>
                </div>  
                <div :class="FormularData.Utilisation!='Logement en location'? 'box big-box' : 'box boxActive big-box'" v-on:click="() => FormularData.Utilisation = 'Logement en location' ">
                  <img src="../../assets/imgused/location.png" class="imgauto" />
                  <span class="radiotitlewithimage">Logement en location</span>
                </div>  
              </div>
            </div>
          </div>

          <div
            id="ifisAppartement"
            v-if="FormularData.Utilisation == 'Logement en location'"
          >
            <h1 class="titleprimary">
              <span class="titlecolorized">Type de </span>
              <span class="titlenoncolorized"> location </span>
            </h1>

            <div class="block blockCenter columns justufuCenter">
              <div class="containerAsurence">
                <div :class="FormularData.TypeLocation!='Meublé'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeLocation = 'Meublé' ">
                  <img src="../../assets/imgused/sofa.png" class="imgauto" />
                  <span class="radiotitlewithimage">Meublé</span>
                </div>  
                <div :class="FormularData.TypeLocation!='Non meublé'? 'box small-box' : 'box boxActive small-box'" v-on:click="() => FormularData.TypeLocation = 'Non meublé' ">
                  <img src="../../assets/imgused/box.png" class="imgauto" />
                  <span class="radiotitlewithimage">Non meublé</span>
                </div>  
              </div>
            </div>
          </div>

          <span v-on:click="Validate4()" id="validation4" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="AdresseVehicule">
          <h1 class="titleprimary">
            <span class="titlecolorized">Adresse de </span>
            <span class="titlenoncolorized">mon Logement ?</span>
          </h1>
          <b-field
            label="Trouvez mon adresse"
            :type="{ 'is-danger': Control.CarAdress }"
            :message="{
              'Veuillez cherchez votre adresse': Control.CarAdress,
            }"
          >
            <b-autocomplete
              :data="temporarCodes"
              placeholder="e.g. Paris"
              field="nomCommune"
              :loading="isFetching"
              @typing="getAsyncData"
              @select="(option) => (FormularData.CarAdress = option)"
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-left codepostalCode">
                    {{ props.option.codePostal }}
                  </div>
                  <div class="media-content postalCodeContent">
                    {{ props.option.nomCommune }}
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>

          <span v-on:click="Validate5()" id="validation5" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="nombre de pieces">
          <h1 class="titleprimary">
            <span class="titlecolorized">Nombre de</span>
            <span class="titlenoncolorized"> pièces</span>
          </h1>

          <h6 class="textsubtitle">
            Il y a des pièces à ne pas comptabiliser comme par exemple
            <span class="colorizedspan">la cuisine fermée</span> ou
            <span class="colorizedspan">salle de bain</span>
          </h6>

          <br />

          <div class="elementCentred">
            <b-field>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="0"
                value="0"
                type="is-primary is-light is-outlined"
              >
                0
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="1"
                value="1"
                type="is-primary is-light is-outlined"
              >
                1
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="2"
                value="2"
                type="is-primary is-light is-outlined"
              >
                2
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="3"
                value="3"
                type="is-primary is-light is-outlined"
              >
                3
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="4"
                value="4"
                type="is-primary is-light is-outlined"
              >
                4
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="5"
                value="5"
                type="is-primary is-light is-outlined"
              >
                5
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="6"
                value="6"
                type="is-primary is-light is-outlined"
              >
                6
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="7"
                value="7"
                type="is-primary is-light is-outlined"
              >
                7
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.NombresPieces"
                native-value="8+"
                value="8+"
                type="is-primary is-light is-outlined"
              >
                8+
              </b-radio-button>
            </b-field>
          </div>

          <span v-on:click="Validate6()" id="validation6" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="nombre de pieces p50m2">
          <h1 class="titleprimary">
            <span class="titlecolorized">Pièces de </span>
            <span class="titlenoncolorized"> plus de 50m2</span>
          </h1>

          <h6 class="textsubtitle">
            <span class="colorizedspan">Parmi les pièces </span> que vous venez
            de renseigner, combien en avez-vous de plus de
            <span class="colorizedspan"> 50m2 </span> ?
          </h6>

          <br />

          <div class="elementCentred">
            <b-field>
              <b-radio-button
                v-model="FormularData.P50m2"
                native-value="0"
                value="0"
                type="is-primary is-light is-outlined"
              >
                0
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.P50m2"
                native-value="1"
                value="1"
                type="is-primary is-light is-outlined"
              >
                1
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.P50m2"
                native-value="2"
                value="2"
                type="is-primary is-light is-outlined"
              >
                2
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.P50m2"
                native-value="3"
                value="3"
                type="is-primary is-light is-outlined"
              >
                3
              </b-radio-button>
              <b-radio-button
                v-model="FormularData.P50m2"
                native-value="4"
                value="4"
                type="is-primary is-light is-outlined"
              >
                4
              </b-radio-button>
            </b-field>
          </div>

          <span v-on:click="Validate7()" id="validation7" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="autres pièces">
          <h1 class="titleprimary">
            <span class="titlecolorized">Mes</span>
            <span class="titlenoncolorized"> autres pièces</span>
          </h1>

          <h6 class="textsubtitle">
            <span class="colorizedspan">Dépendance de plus de 30m2</span>
          </h6>
          <small class="smalltext"
            >Garages, caves, granges, remises, hangars et tout autre bâtiment
            attenant ou non aux locaux d'habitation.</small
          >
          <div class="spaceclass"></div>
          <div class="elementCentred">
            <b-field>
              <b-radio-button
                v-model="FormularData.P30m2"
                native-value="0"
                value="0"
                type="is-primary is-light is-outlined"
              >
                0
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.P30m2"
                native-value="1"
                value="1"
                type="is-primary is-light is-outlined"
              >
                1
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.P30m2"
                native-value="2+"
                value="2+"
                type="is-primary is-light is-outlined"
              >
                2+
              </b-radio-button>
            </b-field>
          </div>
          <div class="spaceclass"></div>
          <h6 class="textsubtitle">
            <span class="colorizedspan">Véranda</span>
          </h6>

          <div class="spaceclass"></div>

          <div class="elementCentred">
            <b-field>
              <b-radio-button
                v-model="FormularData.Veranda"
                native-value="Oui"
                value="Oui"
                type="is-primary is-light is-outlined"
              >
                Oui
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.Veranda"
                native-value="Non"
                value="Non"
                type="is-primary is-light is-outlined"
              >
                Non
              </b-radio-button>
            </b-field>
          </div>
          <span v-on:click="Validate8()" id="validation8" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="History">
          <h1 class="titleprimary">
            <span class="titlecolorized">Durant les</span>
            <span class="titlenoncolorized"> 3 dernières années</span> ...
          </h1>

          <h6 class="historytitle">Mon historique d'assurance</h6>
          <h6 class="textsubtitle">
            Avez-vous eu un contrat résilié avec une autre compagnie d'assurance
            ?
          </h6>
          <br />

          <div class="columns width-100-mobile">
            <div class="column width-50-mobile">
              <b-radio-button
                v-model="FormularData.History"
                native-value="Oui"
                value="Oui"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Oui</span>
              </b-radio-button>
            </div>
            <div class="column width-50-mobile">
              <b-radio-button
                v-model="FormularData.History"
                native-value="Non"
                value="Non"
                type="is-success  is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
          </div>

          <h6 class="historytitle">Mes sinistres</h6>
          <h6 class="textsubtitle">
            Combien de sinistres avez-vous eu
            <span class="colorizedspan"> les 3 dérniéres années </span> ?
          </h6>
          <br />

          <div class="elementCentred">
            <b-field>
              <b-radio-button
                v-model="FormularData.Sinstre"
                native-value="0"
                value="0"
                type="is-primary is-light is-outlined"
              >
                0
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.Sinstre"
                native-value="1"
                value="1"
                type="is-primary is-light is-outlined"
              >
                1
              </b-radio-button>

              <b-radio-button
                v-model="FormularData.Sinstre"
                native-value="2+"
                value="2+"
                type="is-primary is-light is-outlined"
              >
                2+
              </b-radio-button>
            </b-field>
          </div>

          <span v-on:click="Validate9()" id="validation9" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Date De Naissance">
          <h1 class="titleprimary">
            <span class="titlecolorized">Ma </span>
            <span class="titlenoncolorized"> Date de naissance ?</span>
          </h1>
          

          <div class="dateElementClass" v-if="isConnected == 1">
            <b-field>
              <b-datepicker
                :max-date="maxDate"
                v-model="FormularData.NaissanceDate"
                :show-week-number="Config.showWeekNumber"
                placeholder="Selectionner votre date de naissance."
                id="naissanceDate"
                ref="datepicker"
                readonly
              >
              </b-datepicker>
            </b-field>
          </div>
          <div class="dateElementClass" v-else>
            <b-field>
              <b-datepicker
                :max-date="maxDate"
                v-on:click="openTogglerDate('naissanceDate')"
                v-model="FormularData.NaissanceDate"
                :show-week-number="Config.showWeekNumber"
                placeholder="Selectionner votre date de naissance."
                id="naissanceDate"
                ref="datepicker"
              >
              </b-datepicker>
            </b-field>
          </div>

          <span v-on:click="Validate10()" id="validation10" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="About your Company">
          <h1 class="titleprimary">
            <span class="titlecolorized">A qui ai je l'</span>
            <span class="titlenoncolorized">Honneur</span>
          </h1>
          <div class="whoimDiv">
            <b
              type="is-danger"
              class="whoIm"
              message="Entrer le nom de l'assuré"
              >Je suis ?
            </b>
            <br />
            <b-radio
              v-model="FormularData.Genre"
              name="genre"
              native-value="Monsieur"
              value="Monsieur"
            >
              Monsieur
            </b-radio>
            <b-radio
              v-model="FormularData.Genre"
              name="genre"
              native-value="Madame"
              value="Madame"
            >
              Madame
            </b-radio>
          </div>
          
          <div class="columns">
            <div class="column">
              <b-field
                label="Mon nom"
                :type="{ 'is-danger': Control.NomAssuree }"
                :message="{
                  'Veuillez entrer votre nom': Control.NomAssuree,
                }"
              >
                <b-input
                  name="subject"
                  v-model="FormularData.Nom"
                  expanded
                  :readonly="isReadOnly"
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Mon prénom"
                :type="{ 'is-danger': Control.PrenomAssuree }"
                :message="{
                  'Veuillez entrer votre prénom': Control.PrenomAssuree,
                }"
              >
                <b-input
                  name="subject"
                  v-model="FormularData.Prenom"
                  expanded
                  :readonly="isReadOnly"
                ></b-input>
              </b-field>
            </div>
          </div>

          <span v-on:click="Validate11()" id="validation11" class="hideclass"
            >Validate</span
          >
        </tab-content>
        <tab-content title="Finishing Up">
          <h1 class="titleprimary">
            <span class="titlecolorized">Mes </span>
            <span class="titlenoncolorized"> Contacts</span>
          </h1>
          <div>
            <b-field
              label="Mon adresse e-mail"
              :type="{ 'is-danger': Control.Email }"
              :message="{ 'Veuillez entrer un email valide': Control.Email }"
            >
              <b-input
                placeholder="Mon adresse e-mail"
                v-model="FormularData.Email"
                type="email"
                icon="fa fa-envelope fa"
                :readonly="isReadOnly"
              >
              </b-input>
            </b-field>

            <b-field
              label="Mon numéro de téléphone"
              :type="{ 'is-danger': Control.Phone }"
              :message="{
                'Veuillez entrer un numéro de téléphone valide': Control.Phone,
              }"
            >
              <b-input
                placeholder="Mon numéro de téléphone"
                v-model="FormularData.Phone"
                type="text"
                icon="fa fa-phone-alt fa"
                icon-right-clickable
                :readonly="isReadOnly"
              >
              </b-input>
            </b-field>
          </div>

          <span v-on:click="Validate12()" id="validation12" class="hideclass"
            >Validate</span
          >

          <h6
            v-on:click="Submit()"
            id="submitform"
            class="hideclass invisibleclass"
          >
            Submit
          </h6>
        </tab-content>

        <!-- <tab-content title="Mon Compte">
          <h1 class="titleprimary">
            <span class="titlecolorized">Mon </span>
            <span class="titlenoncolorized"> Compte</span>
          </h1>

          

          <div v-if="isConnected == '1'">vous etes deja connecté</div>
          <div v-else>
            <b-field>
              <b-checkbox size="is-large" v-model="FormularData.isAccount"
                >Créer un compte</b-checkbox
              >
            </b-field>

            <div v-if="FormularData.isAccount" class="columns">
              <div class="column">
                <b-field label="Mots de passe">
                  <b-input
                    type="password"
                    value="iwantmytreasure"
                    password-reveal
                    v-model="M"
                  >
                  </b-input>
                </b-field>
              </div>

              <div class="column">
                <b-field label="Confirmer votre mot de passe">
                  <b-input
                    type="password"
                    value="iwantmytreasure"
                    password-reveal
                    v-model="M2"
                  >
                  </b-input>
                </b-field>
              </div>
            </div>
          </div>
          <span v-on:click="Validate13()" id="validation13" class="hideclass"
            >Validate</span
          >
          <h6
            v-on:click="Submit()"
            id="submitform"
            class="hideclass invisibleclass"
          >
            Submit
          </h6>
        </tab-content> -->
      </form-wizard>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IntroductionHabitation from "../../components/IntroductionHabitation.vue";
import FormWizard from "../../components/FormWizard.vue";
import TabContent from "../../components/TabContent.vue";
import debounce from "lodash/debounce";
import postalCode from "../../assets/postalCode.json";
import { submitHabitation , getProfile} from "../../_services/api";
import ValidationHelper from "../../components/ValidationHelper.vue";
import Buefy from "buefy";
import Vue from "vue";

Vue.use(Buefy, {
  defaultIconPack: "fa",
  defaultContainerElement: "#content",
});

Vue.prototype.$http = axios;
export default {
  name: "SimpleStepperHabitation",
  components: {
    FormWizard,
    TabContent,
    IntroductionHabitation,
  },
  mixins: [ValidationHelper],
  data() {
    return {
      isReadOnly : false,
      data: [],
      temporarCodes: [],
      temporarCodesCar: [],
      selected: null,
      isFetching: false,
      isFetchingCar: false,
      postalCode: postalCode.Codes,
      Cars: [],
      maxDate: new Date(),
      Config: {
        showWeekNumber: false,
        currentTab: 0,
      },
      SearchQuery: null,
      ClaimsData: [],
      isFullPage: true,
      isLoading: false,
      Control: {
        CarAdress: false,
        Email: false,
        Phone: false,
        NomAssuree: false,
        PrenomAssuree: false,
      },
      M: null,
      M2: null,
      isConnected: 0,
      FormularData: {
        Hidden: null,
        isAccount: 1,
        isPro: 0,
        TypeLocation: "NA",
        TypeAppartement: "NA",
        Sinstre: "0",
        Veranda: null,
        P30m2: null,
        P50m2: "0",
        NombresPieces: null,
        Utilisation: null,
        TypeLogement: "Maison",
        Phone: null,
        Bref: null,
        Email: null,
        Nom: null,
        Prenom: null,
        Genre: "Monsieur",
        History: "Oui",
        Seniority: "Oui",
        NaissanceDate: new Date(),
        CarAdress: null,
        isOwner: "Oui",
        
      },
    };
  },
  mounted() {
    let today = new Date();
    this.maxDate = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    this.FormularData.NaissanceDate = this.maxDate;
  },

  methods: {
    validateStep(id) {
      document
        .getElementById("validation" + id)
        .setAttribute("validation", "validated");
    },
    unvalidateStep(id) {
      document
        .getElementById("validation" + id)
        .setAttribute("validation", "notvalidated");
    },
    customAlert(msg) {
      this.$buefy.dialog.alert({
        title: "Malhereusement",
        message: msg,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    validatePhone(phone) {
      if (phone.length == 10 && !isNaN(phone)) {
        return false;
      } else {
        return true;
      }
    },
    CheckPhone(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || Element == null || this.validatePhone(Element)) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      if (re.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    CheckEmail(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || this.validateEmail(Element)) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    CheckEntityisNotEmpty(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || Element == null) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    Validate1() {
      this.validateStep("1");

      this.FormularData.TypeAppartement = "NA";
      this.FormularData.TypeLogement = "Maison";
    },
    Validate2() {
      this.unvalidateStep("2");
      if (this.FormularData.TypeLogement == "Appartement") {
        if (this.FormularData.TypeAppartement == "NA") {
          this.customAlert(
            "Vous devez choisir a <b> quel étage habitez vous</b> pour continuer"
          );
        } else {
          this.validateStep("2");
        }
      } else {
        this.validateStep("2");
      }
    },
    alertCustomError() {
      this.customAlert(
        "Cette fonctionnalité sera <b>prochainement disponible</b>"
      );
    },
    Validate3() {
      this.validateStep("3");
      this.FormularData.Utilisation = null;
      this.FormularData.TypeLocation = "NA";
    },
    Validate4() {
      if (this.FormularData.Utilisation == null) {
        this.unvalidateStep("4");
        this.customAlert(
          "Vous devez choisir l'<b>Utilisation de votre logement</b> pour continuer"
        );
      } else {
        if (this.FormularData.Utilisation == "Logement en location") {
          if (this.FormularData.TypeLocation == "NA") {
            this.customAlert(
              "Vous devez choisir le <b>type de location</b> pour continuer"
            );
            this.unvalidateStep("4");
          } else {
            this.validateStep("4");
          }
        } else {
          this.validateStep("4");
        }
      }
    },
    Validate5() {
      if (this.FormularData.CarAdress != null) {
        this.validateStep("5");
        this.FormularData.NombresPieces = null;
      } else {
        this.customAlert(
          "Vous devez choisir <b>votre adresse postale</b> pour continuer"
        );

        this.unvalidateStep("5");
      }
    },
    Validate6() {
      if (this.FormularData.NombresPieces == null) {
        this.unvalidateStep("6");
        this.customAlert(
          "Vous devez choisir le <b> nombre de piéces</b> pour continuer"
        );
      } else {
        this.FormularData.P50m2 = null;
        this.validateStep("6");
      }
    },
    Validate7() {
      if (this.FormularData.P50m2 == null) {
        this.unvalidateStep("7");
        this.customAlert(
          "Vous devez choisir le nombre de <b> piéces de 50m2 </b> dans votre logement pour continuer"
        );
      } else {
        this.FormularData.P30m2 = null;
        this.FormularData.Veranda = null;
        this.validateStep("7");
      }
    },
    Validate8() {
      this.unvalidateStep("8");
      if (this.FormularData.Veranda == null) {
        this.customAlert(
          "Merci de choisir si vous avez <b>Veranda</b> dans votre logement"
        );
      } else if (this.FormularData.P30m2 == null) {
        this.customAlert(
          "Vous devez choisir le nombre de <b> piéces de 30m2 </b> dans votre logement pour continuer"
        );
      } else {
        this.validateStep("8");
      }
    },
    Validate9() {
      this.validateStep("9");
    },
    Validate10() {
      this.validateStep("10");
    },
    Validate11() {
      let FinalValue = "";
      let Results = [];
      let that = this.FormularData;
      let Control = this.Control;

      FinalValue = this.CheckEntityisNotEmpty(that.Nom).FinalValue;
      Results.push(FinalValue);
      Control.NomAssuree = this.CheckEntityisNotEmpty(that.Nom).Control;

      FinalValue = this.CheckEntityisNotEmpty(that.Prenom).FinalValue;
      Results.push(FinalValue);
      Control.PrenomAssuree = this.CheckEntityisNotEmpty(that.Prenom).Control;
      let FinalResult = true;
      for (let i = 0; i < Results.length; i++) {
        if (Results[i] == false) {
          FinalResult = false;
        }
      }
      if (FinalResult == true) {
        this.validateStep("11");
      } else {
        this.unvalidateStep("11");
      }
    },

    Validate12() {
      let FinalValue = "";
      let Results = "";
      let ResultsPhone = "";
      let that = this.FormularData;
      let Control = this.Control;

      FinalValue = this.CheckEmail(that.Email).FinalValue;
      Results = FinalValue;
      Control.Email = this.CheckEmail(that.Email).Control;

      FinalValue = this.CheckPhone(that.Phone).FinalValue;
      ResultsPhone = FinalValue;
      Control.Phone = this.CheckPhone(that.Phone).Control;

      if (Results == true && ResultsPhone == true) {
        this.validateStep("12");
      } else {
        this.unvalidateStep("12");
      }
    },

    /*
    Validate13() {
      if (this.isConnected) {
        this.validateStep("13");
      } else {
        let M = this.M.trim();
        let M2 = this.M2.trim();
        if (this.FormularData.isAccount) {
          if (M == null || M2 == null) {
            this.unvalidateStep("13");
            this.customError(
              "Vous devez entrer et confirmer votre mot de passe"
            );
          } else {
            if (M.length < 8) {
              this.unvalidateStep("13");
              this.customError(
                "Merci de choisir un mot de passe supérieur a 8 chiffres/lettres"
              );
            } else {
              if (M !== M2) {
                this.unvalidateStep("13");
                this.customError(
                  "Merci de choisir confirmer votre mot de passe"
                );
              } else {
                this.FormularData.Hidden = M;
                this.validateStep("13");
              }
            }
          }
        } else {
          this.validateStep("13");
        }
      }
    },

    */
    hideElement(id) {
      document.getElementById(id).classList.add("hideclass");
    },
    showElement(id) {
      document.getElementById(id).classList.remove("hideclass");
    },

    Submit() {},
    clearDate() {
      this.FormularData.NaissanceDate = null;
    },
    logging() {},

    onComplete() {
      let there = this;
      there.isLoading = true;
      let jsonText =this.FormularData;

      submitHabitation(jsonText)
        .then(function () {
          document.getElementById("message").style.display = "block";
          document.getElementById("formularor").style.display = "none";
          there.isLoading = false;
        })
        .catch(function () {
          there.isLoading = false;
        });
    },

    reset() {
      for (let field in this.formData) {
        this.formData[field] = null;
      }
    },

    nextStep() {
      this.currentTab = this.currentTab + 1;
    },

    previousStep() {
      //alert("On Previous Step");
    },
    openTogglerDate(id) {
      document.getElementById(id).click();
    },
    filtreTexteForPostalCode(arr, requete) {
      return arr.filter(function (el) {
        return (
          el.codePostal.toLowerCase().indexOf(requete.toLowerCase()) !== -1 ||
          el.nomCommune.toLowerCase().indexOf(requete.toLowerCase()) !== -1
        );
      });
    },
    fetchAdress(adresse) {
      this.temporarCodes = [];
      for (let i = 0; i < adresse.length; i++) {
        let me = {
          codePostal: adresse[i].properties.postcode,
          nomCommune: adresse[i].properties.label,
        };
        this.temporarCodes.push(me);
      }
    },
    getAsyncData: debounce(function (name) {
      if (!name.length) {
        this.data = [];
        return;
      }
      this.isFetching = true;
      if (name.length > 3) {
        axios
          .get(
            "https://api-adresse.data.gouv.fr/search/?q=" +
              name +
              "&type=housenumber&autocomplete=1"
          )
          .then(
            (response) => this.fetchAdress(response.data.features) //this.Brands = response.data.Brands
          )
          .catch();
      }
      this.isFetching = false;
    }, 500),
  },
};
</script>

<style scoped>
@import url('../../assets/common.css');
@import url('../../assets/mystyle.css');
@import url('../../assets/stepper.css');
@import url('../../assets/buefy.css');
</style>